import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useData } from "@/context/DataContext";
import { isoDate } from "@/lib/format";
import { DatePicker } from "@/components/DatePicker";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { REQ_KINDS } from "@/components/privacy/privacyConst";

const EXT = "__external__";
const empty = () => ({ employee_id: null, requester_name: "", requester_email: "", kind: "accesso", received_on: isoDate(new Date()), channel: "", notes: "" });

export const RequestDialog = ({ open, onClose, onSaved }) => {
  const { employees } = useData();
  const [f, setF] = useState(empty());
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF(empty()); }, [open]);
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));
  const save = async () => {
    setBusy(true);
    try { const r = await api.post("/privacy/requests", f); toast.success("Richiesta registrata: gli amministratori sono stati avvisati"); onSaved(r.data); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[90vh] max-w-xl overflow-y-auto" data-testid="request-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Nuova richiesta privacy</DialogTitle></DialogHeader>
        <div className="grid gap-4 sm:grid-cols-2">
          <div className="sm:col-span-2"><Label className="micro-label">Interessato</Label>
            <Select value={f.employee_id || EXT} onValueChange={(v) => set("employee_id")(v === EXT ? null : v)}>
              <SelectTrigger className="mt-1.5" data-testid="request-field-employee"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value={EXT}>Persona esterna (ex candidato, cliente…)</SelectItem>{employees.map((e) => <SelectItem key={e.id} value={e.id}>{e.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          {!f.employee_id && <>
            <div><Label className="micro-label">Nome e cognome</Label><Input className="mt-1.5" value={f.requester_name} onChange={(e) => set("requester_name")(e.target.value)} data-testid="request-field-name" /></div>
            <div><Label className="micro-label">Email</Label><Input className="mt-1.5" value={f.requester_email} onChange={(e) => set("requester_email")(e.target.value)} data-testid="request-field-email" /></div>
          </>}
          <div><Label className="micro-label">Tipo di richiesta</Label>
            <Select value={f.kind} onValueChange={set("kind")}><SelectTrigger className="mt-1.5" data-testid="request-field-kind"><SelectValue /></SelectTrigger>
              <SelectContent>{Object.entries(REQ_KINDS).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent></Select>
          </div>
          <div><Label className="micro-label">Ricevuta il (scadenza +30 giorni)</Label><div className="mt-1.5"><DatePicker value={f.received_on} onChange={set("received_on")} maxDate={new Date()} testId="request-field-received" /></div></div>
          <div className="sm:col-span-2"><Label className="micro-label">Canale (email, PEC, lettera…)</Label><Input className="mt-1.5" value={f.channel} onChange={(e) => set("channel")(e.target.value)} data-testid="request-field-channel" /></div>
          <div className="sm:col-span-2"><Label className="micro-label">Note</Label><Textarea className="mt-1.5" rows={2} value={f.notes} onChange={(e) => set("notes")(e.target.value)} data-testid="request-field-notes" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annulla</Button>
          <Button onClick={save} disabled={busy || (!f.employee_id && !f.requester_name.trim())} data-testid="request-save-button">Registra</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
